import qfSignals from "quickfire/qf-signals";
import { VEventEnum } from "quickfire/v/enums";
import GameState from "slotworks/model/game-state";
import { Transaction } from "slotworks/services/transaction/transaction";
import Contract from "slotworks/utils/contracts/contract";

export class VTransaction extends Transaction {

    private previousTotalWin: number;

    constructor() {
        super();

        qfSignals.get(VEventEnum.systemBalanceUpdate).add((balance: {value: number}) => {
            GameState.getCurrentGame().balance = balance.value;
            this.setBalance(balance.value);
        });
    }

    public setBalance(value: number) {
        if (value !== this.previousBalance) {
            qfSignals.dispatch(VEventEnum.balanceUpdate, value);
        }

        super.setBalance(value);
    }

    public setWinnings(currentWin: number, totalWin?: number, tickTime: number = 0): Contract<void> {
        return new Contract<void>((resolve) => {
            super.setWinnings(currentWin, totalWin, tickTime).then(() => {
                if (totalWin !== this.previousTotalWin) {
                    this.previousTotalWin = totalWin;
                    qfSignals.dispatch(VEventEnum.winUpdate, totalWin);
                }
                resolve(null);
            });
        });
    }
}
